import React from 'react'
import {NullAsDefault} from 'views/Shared'
import Translate from "../../../../modules/local/Translate";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import _ from "lodash";
import {DoubleValueItem, SacramentItem} from "../components/CatholicHouseholdComponents";
import Toggle from "../../../../components/Toggle";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {renderIf, renderIfElse} from "../../../Shared";
import EmptyHolder from "../../../../components/EmptyHolder";
import {Avatar} from "antd";
import {RiUser2Fill} from "react-icons/ri";
import CRUD from "../../../Shared/enums/CRUD";
import {GiIronCross, GiPlainCircle} from "react-icons/gi";
import classNames from "classnames";
import {CatholicHouseholdStatus} from "../../../Workspace/CatholicHousehold/functions/renderCatholicHousehold";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getTitle from "../../../../helpers/getTitle";
import getAliasName from "../../../../helpers/getAliasName";
import {formatDate} from "../../../../helpers/datetimeHelpers";


export const renderCatholicHouseholdMember = ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {

    const { patron_saint_name, name, birth_province, birth_date, sacraments = [], member_user, status, others } = item ?? {}

    const current_status = _.find(CatholicHouseholdStatus, {value: status}) ?? {}

    return (
        <LayoutContext.Consumer>
            {({isSm}) => (
                <Translate key={index}>
                    {(t) => (
                        <div key={index} className="py-2 flex gap-1 rounded-lg custom-item-render custom-render-border relative">
                            <div className="flex flex-col flex-1 gap-1">
                                <div className="flex items-center gap-2 relative">
                                    <Avatar
                                        size={40}
                                        src={member_user?.avatar}
                                        icon={<RiUser2Fill size={20} className="text-color-500"/>}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col flex-1">
                                        <div
                                            onClick={() => {handleAction(CRUD.READ, item)}}
                                            className="font-bold text-color-000 hover:text-primary cursor-pointer leading-snug">
                                            {getAliasName(item, 'patron_saint') || ''}
                                            {` ${name}`}
                                        </div>
                                        {renderIf(
                                            _.some([birth_date, birth_province]),
                                            <DoubleValueItem
                                                showIcon={true}
                                                labelFirst="date of birth"
                                                valueFirst={birth_date ? formatDate(birth_date, 'DD/MM/YYYY') : t('not update')}
                                                labelSecond="in"
                                                valueSecond={birth_province ? birth_province?.location_name : t('not update')}
                                                className="text-xs"
                                            />
                                        )}
                                    </div>
                                    {renderIf(
                                        status !== 1,
                                        <div
                                            style={{ bottom: -5 }}
                                            className={classNames("absolute right-5 font-medium text-2xs italic", current_status?.className)}>
                                            {t(current_status?.label)}
                                        </div>
                                    )}
                                </div>
                                <Toggle>
                                    {(isToggle, toggle) => (
                                        <div style={{ marginLeft: 15 }} className="flex flex-col">
                                            {renderIf(
                                                sacraments.length > 0,
                                                <div className="mt-2 flex items-center gap-4">
                                                    <HeaderWithIconLine
                                                        line={false}
                                                        renderTitle={() => (
                                                            <div className="flex items-center gap-1 font-medium text-sm">
                                                                <GiIronCross size={10} className="text-color-400 mr-1" />
                                                                <span className="text-color-400 uppercase tracking-wide">
                                                                {`${t('sacraments received')}`}
                                                            </span>
                                                                {renderIf(
                                                                    sacraments.length > 0,
                                                                    <span style={{ fontSize: 11 }} className="font-bold text-blue-600 leading-snug">
                                                                    {`( ${sacraments.length} )`}
                                                                </span>
                                                                )}
                                                            </div>
                                                        )}
                                                        className="flex-1 leading-snug"
                                                    />
                                                    {renderIfElse(
                                                        sacraments.length > 0,
                                                        <div
                                                            onClick={() => {toggle()}}
                                                            className="text-right text-xs text-color-500 hover:text-color-100 italic cursor-pointer">
                                                            {isToggle ? `...${t('see less')}` : `${t('see more')}...`}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {isToggle && renderIfElse(
                                                sacraments.length > 0,
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2 md:gap-x-3 gap-y-1">
                                                    {sacraments.map((e,i) => (
                                                        <SacramentItem key={i} item={e} />
                                                    ))}
                                                </div>,
                                                <EmptyHolder />
                                            )}
                                        </div>
                                    )}
                                </Toggle>
                                <Toggle>
                                    {(isToggle, toggle) => (
                                        <div className="flex flex-col mt-1">
                                            {renderIf(
                                                others.length > 0,
                                                <div
                                                    onClick={() => {toggle()}}
                                                    className="flex items-center gap-2 mb-1">
                                                    <div style={{ marginLeft: !isSm && 16 }} className="flex items-center flex-1 gap-2 font-medium">
                                                        <GiIronCross size={9} className="text-color-400" />
                                                        <span className="text-sm text-color-400 uppercase tracking-wide leading-tight">
                                                                {`${t('catholic household other')}`}
                                                            </span>
                                                        {renderIf(
                                                            others.length > 0,
                                                            <span style={{ fontSize: 10 }} className="font-bold text-primary-400 leading-snug">
                                                                    {`( ${others.length} )`}
                                                                </span>
                                                        )}
                                                    </div>
                                                    <span className="text-xs text-color-500 hover:text-color-100 italic tracking-wide cursor-pointer">
                                                        {isToggle ? `...${t('see less')}` : `${t('see more')}...`}
                                                    </span>
                                                </div>
                                            )}
                                            {renderIf(
                                                isToggle && others.length > 0,
                                                <div style={{ marginLeft: isSm ? 7 : 24}} className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1">
                                                    {others.map((eee, iii) => (
                                                        <div  key={iii} className="flex items-center gap-2">
                                                            <GiPlainCircle size={9} className="text-primary-100"/>
                                                            <Link target="_blank"
                                                                  to={getLinkToDetail(eee)}
                                                                  className="font-semibold text-sm text-primary-500 italic no-underline">
                                                                {`${t('catholic household')} ${getTitle(eee)}`}
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </Toggle>
                            </div>
                            {renderIf(
                                !!item?.edit && _.isFunction(renderContextMenu),
                                <div className="absolute right-5 top-5 contextIcon">
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )}
        </LayoutContext.Consumer>
    )
}



